import {Component, input, output} from '@angular/core';
import {MatDivider} from "@angular/material/divider";
import {MatMenu, MatMenuItem, MatMenuModule} from "@angular/material/menu";
import {NgIf} from "@angular/common";
import {Solution} from "../../../../shared/interfaces/solution";

@Component({
  selector: 'app-select-solution-button',
  standalone: true,
  imports: [
    MatMenuModule,
    MatDivider,
    MatMenu,
    MatMenuItem,
    NgIf
  ],
  templateUrl: './select-solution-button.component.html',
  styleUrl: './select-solution-button.component.scss'
})
export class SelectSolutionButtonComponent {
  availableSolutions = input<Solution[]>();
  solutionSelected = output<Solution>();
}
